import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import {
  getCurrentMeet,
  getMeetLifters
} from 'selectors';
import {
  getPlatformOptions,
  getSessionOptions,
  getFlightOptions
} from 'util/options';

import './RosterIndex.scss';

const Lifters = ({ lifters, meet }) => {
  const sortedLifters = _.sortBy(lifters, ['lot', 'name']);
  return (
    <ul>
      {
        _.map(sortedLifters, (lifter) => {
          return (
            <li key={lifter._id}>
              <Link to={`/meets/${_.get(meet, '_id')}/lifter/${lifter._id}`}>
                { lifter.lot && <span>{lifter.lot} - </span>}{lifter.name}
              </Link>
            </li>
          );
        })
      }
    </ul>
  );
};

const Session = ({lifters, meet, session, platforms}) => {
  const sessionLifters = _.filter(lifters, {session: session.value});
  const sessionCount = _.size(sessionLifters);

  if(!sessionCount) {
    return null;
  }

  const platformUnassignedLifters = _.filter(sessionLifters, (l) => !l.platformId);
  const platformUnassignedCount = _.size(platformUnassignedLifters);

  return (
    <div key={session.value} className="session-roster">
      <h2>Session {session.label} ({sessionCount})</h2>
      <div className="session-content">
        { platformUnassignedCount !== 0 &&
          <div className="platform-list-wrapper">
            <h3>Platform Unassigned ({platformUnassignedCount})</h3>
            <Lifters meet={meet} lifters={platformUnassignedLifters} />
          </div>
        }
        {
          _.map(platforms, (platform) => {
            return (
              <Platform key={platform.value} sessionLifters={sessionLifters} platform={platform} meet={meet} />
            );
          })
        }
      </div>
    </div>
  );
};

const Platform = ({sessionLifters, platform, meet}) => {
  const platformLifters = _.filter(sessionLifters, {platformId: platform.value});
  const platformCount = _.size(platformLifters);

  if(!platformCount) {
    return null;
  }

  const flightUnassignedLifters = _.filter(platformLifters, (l) => !l.flight);
  const flightUnassignedCount = _.size(flightUnassignedLifters);

  return (
    <div className="platform-list-wrapper">
      <h3>Platform {platform.label} ({platformCount})</h3>
      <ul className="platform-list">
        { flightUnassignedCount !== 0 &&
          <li>
            Flight Unassigned ({flightUnassignedCount})
            <Lifters meet={meet} lifters={flightUnassignedLifters} />
          </li>
        }
        {
          _.map(getFlightOptions(), (flight) => {
            const flightLifters = _.filter(platformLifters, {flight: flight.value});
            const flightCount = _.size(flightLifters);

            if(!flightCount) {
              return null;
            }

            return (
              <li key={flight.value}>
                Flight {flight.label} ({flightCount})
                <Lifters meet={meet} lifters={flightLifters} />
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};

class RosterIndex extends Component {

  render() {
    const { meet, lifters } = this.props;
    const platforms = getPlatformOptions({}, meet);

    const sessionUnassignedLifters = _.filter(lifters, (l) => !l.session);
    const sessionUnassignedCount = _.size(sessionUnassignedLifters);

    return (
      <div className="roster-index">
        <div className="meet-info-row"><label>Total Lifters:</label> ({_.size(lifters)})</div>
        <div className="meet-info-row"><label>Date:</label> {meet.date}</div>
        <div className="meet-info-row"><label>Units:</label> {meet.units}</div>
        { sessionUnassignedCount !== 0 &&
          <div className="session-roster">
            <h2>Session Unassigned ({sessionUnassignedCount})</h2>
            <div className="session-content">
              <Lifters meet={meet} lifters={sessionUnassignedLifters} />
            </div>
          </div>
        }

        {
          _.map(getSessionOptions(), (session) => {
            return (
              <Session key={session.value} lifters={lifters} meet={meet} platforms={platforms} session={session} />
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    lifters: getMeetLifters(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(RosterIndex);
